import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'categorias-productos/';

// ── Interfaces ──────────────────────────────────────────────

export interface SucursalInfo {
    id: number;
    nombre: string;
}

export interface CategoriaProducto {
    id: number;
    nombre: string;
    descripcion: string;
    activo: boolean;
    sucursal: number;
    sucursal_info: SucursalInfo | null;
}

export interface CategoriaProductoFormData {
    nombre: string;
    descripcion?: string;
    activo?: boolean;
    sucursal: number;
}

// ── Peticiones ──────────────────────────────────────────────

/**
 * Obtiene todas las categorías de productos.
 * @param sucursalId Opcional, filtra por sucursal
 */
export const fetchCategoriasProducto = async (
    sucursalId?: number
): Promise<CategoriaProducto[]> => {
    return handleRequestWithAuth(async () => {
        const params: any = {};
        if (sucursalId) params.sucursal_id = sucursalId;
        const response = await axiosInstance.get(API_URL, { params });
        return response.data;
    });
};

/**
 * Obtiene una categoría por su ID.
 */
export const fetchCategoriaProducto = async (
    id: number
): Promise<CategoriaProducto> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}${id}/`);
        return response.data;
    });
};

/**
 * Crea una nueva categoría de producto.
 * @param data Datos de la categoría (sin imagen, solo JSON)
 */
export const createCategoriaProducto = async (
    data: CategoriaProductoFormData
): Promise<CategoriaProducto> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

/**
 * Actualiza una categoría de producto existente (PUT).
 * @param id ID de la categoría
 * @param data Campos a actualizar
 */
export const updateCategoriaProducto = async (
    id: number,
    data: Partial<CategoriaProductoFormData>
): Promise<CategoriaProducto> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

/**
 * Elimina una categoría de producto.
 * @param id ID de la categoría
 */
export const deleteCategoriaProducto = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};